import { UserCheck, FileCheck2, Clock, KeyRound } from 'lucide-react';

const WHY = [
  { icon: UserCheck, title: 'Senior engineers only', desc: 'The people in the kickoff are the people writing the code. No juniors learning on your budget.' },
  { icon: FileCheck2, title: 'Fixed scope or dedicated team', desc: 'A fixed price for well-defined work, or a monthly team when the roadmap is still moving.' },
  { icon: Clock, title: 'EU time zone', desc: 'CET hours: full overlap with Europe and the UK, half a day with the US East Coast.' },
  { icon: KeyRound, title: 'You own everything', desc: 'Code, infrastructure and documentation are yours from day one. No lock-in.' },
];
export default WHY;
